export function responsiveBindingSmallDevices(setterMethod) {
  return responsiveBinding('1024px', setterMethod);
}
export function responsiveBindingMobile(setterMethod) {
  return responsiveBinding('768px', setterMethod);
}
export function responsiveBinding(width, setterMethod) {
  const mql = window.matchMedia(`(max-width: ${width})`);
  setterMethod(mql.matches);
  const handleChange = event => {
    setterMethod(event.matches);
  };
  mql.addEventListener('change', handleChange);
  return () => mql.removeEventListener('change', handleChange);
}